import React, { useEffect, useRef, useState } from 'react'
import './my-microcredentials.styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component';
import NewMcCheck from '../new-mc-check/new-mc-check.component';
import StatusBarWithIcons from './status-bar-with-icons.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ModalAlert } from '@/components/SHARED/modal/modal.component';
import TranscriptDownloadButton from '@/components/SHARED/transcript-download-button/transcript-download-button.component';

const MyMicrocredentials = ({ userProgressNumbers }) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const myMcList = useSelector(state => state.contentData.myMcList);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState([]);
    const loadingRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        if (!myMcList) return;
        loadingRef.current = Object.values(myMcList).map(m => m.mc_key)
        // setLoading(loadingRef.current);
        
    }, [myMcList])

    return (
        <div className='my-microcredentials-container'>
            <div className='my-microcredentials-content'>
                {
                    (myMcList) &&
                    <div className='g-card'>
                        <div className='section-title'>
                            My Micro-Credentials
                            {
                                (userProfile && myMcList) &&
                                <TranscriptDownloadButton
                                    user={userProfile}
                                    mcList={myMcList} />
                            }
                        </div>
                        <hr className='no-top-margin' />
                        <div className='mc-list'>
                        {
                            (myMcList && Object.keys(myMcList).length > 0) 
                            ?
                            Object.values(myMcList)
                            .sort((a,b) => a.name > b.name ? 1 : -1)
                            .map(m => {
                                const progNum = userProgressNumbers ? userProgressNumbers[m.mc_key] : null;
                                console.log(progNum)
                                return (
                                <div key={m.mc_key}>
                                    {
                                        // (!progNum) //m.imported && (
                                        // ?
                                        // <div  className='g-list-item mc-card no-shadow'>
                                        //     <div className='icon-container'>
                                        //         <img src={m.imageUrl} className='icon' />
                                        //     </div>
                                        //     <div className='text-container'>
                                        //         <div className='title'>{m.name}</div>
                                        //         <div className='buttons'>
                                        //             {
                                        //                 (loading) 
                                        //                 ?
                                        //                 <button className='g-button'><ThreeDotsLoader /></button>
                                        //                 :
                                        //                 <button className='g-button' onClick={() => importOldProgress(m.id, m.mc_key)}>Import Data from v1</button>
                                        //             }
                                        //         </div>
                                        //     </div>
                                        // </div>
                                        // :
                                        <div  className='g-list-item mc-card'>
                                            <div className='icon-container'>
                                                <img src={m.imageUrl} className='icon' />
                                            </div>
                                            <div className='text-container'>
                                                <div className='title'>{m.name}</div>
                                                Status:
                                                <div className="g-space-0-5"></div>
                                                {   
                                                    (loading.includes(m.mc_key)) 
                                                    ?
                                                    <div className='buttons'>
                                                        <button className='g-button disabled'><ThreeDotsLoader /></button>
                                                    </div>
                                                    : 
                                                    <div className='status-row'>
                                                        <StatusBarWithIcons 
                                                            progressNumber={progNum} 
                                                            mcData={myMcList[m.mc_key]} />
                                                        {
                                                            (progNum?.legacy)
                                                            ?
                                                            <button
                                                                className='g-button'
                                                                onClick={() => setAlertMessage("This Micro-Credential was completed in the Legacy version of the platform. There is no data in this version of the platform.")}>
                                                                Legacy
                                                            </button>
                                                                :
                                                            <button 
                                                                className='g-button'
                                                                onClick={() => navigate(`/microcredential/${m.mc_key}`)}    
                                                            >
                                                                Open<FontAwesomeIcon icon={faArrowRight} />
                                                            </button>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            )})
                                
                            :
                            <p>No Micro-Credentials Yet...</p>
                        }
                        </div>
                    </div>
                }
            </div>
            <NewMcCheck />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default MyMicrocredentials;